var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-select"},[_c('v-select',{attrs:{"options":_vm.userList,"searchable":true,"placeholder":_vm.placeholder,"loading":_vm.loading},on:{"input":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }